import { render, staticRenderFns } from "./ActivityCalendar.vue?vue&type=template&id=5815b2dc"
import script from "./ActivityCalendar.vue?vue&type=script&lang=js"
export * from "./ActivityCalendar.vue?vue&type=script&lang=js"
import style0 from "./ActivityCalendar.vue?vue&type=style&index=0&id=5815b2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports